<template>
  <div>
    <wc-page-title title='Dashboard'>
      <template v-slot:rightSide>
        <wc-toolbar-search v-model='search'></wc-toolbar-search>
        <v-menu offset-y left>
          <template v-slot:activator='{ on }'>
            <v-btn icon small v-on='on'><v-icon color='grey lighten-1'>mdi-plus</v-icon></v-btn>
          </template>
          <v-subheader>NEW ESTIMATE TYPE</v-subheader>
          <new-estimate-menu @openAdd='openAdd'></new-estimate-menu>
        </v-menu>
      </template>
    </wc-page-title>
    <v-container>
      <v-row>
        <v-col cols='12'>
          <wc-data-box hideToolbar>
            <estimates-table
              :isLoading='isLoading'
              :estimates='filteredEstimates'
              :search='search'
            ></estimates-table>
          </wc-data-box>
        </v-col>
      </v-row>
    </v-container>

    <new-estimate-setup
      :showDialog='showEstimateSetup'
      :division='division'
      @cancel='showEstimateSetup = false'
      :projects='projects'
    ></new-estimate-setup>

  </div>
</template>

<script>
import formRules from '@/mixins/formRules';
import estimatesAPI from '@/modules/estimates/api/estimates';
import irrigationAPI from '@/modules/irrigation/api/irrigations';
import NewEstimateMenu from '@/modules/estimates/components/NewEstimateMenu';
import NewEstimateSetup from '@/modules/estimates/components/NewEstimateSetup';
import EstimatesTable from '../components/EstimatesTable';
import _ from 'lodash';

export default {
  name: 'estimate-list',
  mixins: [formRules],
  data: () => ({
    isLoading: false,
    showEstimateSetup: false,
    isFormValid: false,
    isQuickCreateValid: false,
    search: '',
    showAdd: false,
    clients: [],
    estimates: [],
    templates: [],
    division: {},
    showArchived: false,
    showQuickCreate: false,
    projects: [],
  }),
  computed: {
    filteredEstimates () {
      if (!this.showArchived) {
        return _.orderBy(this.estimates.filter(e => e.archived === false), ['estimate_date', 'name'], ['desc','asc'])
      }
      return _.orderBy(this.estimates, ['estimate_date', 'name'], ['desc','asc'])
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    async getData () {
      this.isLoading = true;
      this.estimates = await estimatesAPI.getUnsoldEstimates();
      this.isLoading = false;
      // we probably want to move the projects call into new estimate setup, so this only calls when needed? - MJ
      // (if so, be sure to look at all instances where this component is called)
      this.projects = _.orderBy(await irrigationAPI.irrigationSelectList(), 'name')
    },
    async openAdd (div) {
      this.division = div;
      this.showEstimateSetup = true;
    }
  },
  components: {
    'new-estimate-menu': NewEstimateMenu,
    'new-estimate-setup': NewEstimateSetup,
    'estimates-table': EstimatesTable
  }
}
</script>
